export default __webpack_public_path__ + "static/media/business_law_banking_15.c59cb727.svg";